import { render, staticRenderFns } from "./ResearchNotes.vue?vue&type=template&id=4e297e48&"
import script from "./ResearchNotes.vue?vue&type=script&lang=js&"
export * from "./ResearchNotes.vue?vue&type=script&lang=js&"
import style0 from "./ResearchNotes.vue?vue&type=style&index=0&id=4e297e48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports